// Каталог уроков и шаги тура.

export const LESSONS = [
  {
    id: 'overview',
    title: 'Знакомство с профильным меню и шапкой сайта',
    description: 'Покажу логотип, аватар и разделы профиля.',
    badgeKey: 'lesson_overview',
    type: 'tour',
  },
  {
    id: 'parts_of_speech',
    title: 'Части речи (видео)',
    description: 'Видео-урок про работу с категориями частей речи.',
    badgeKey: 'lesson_parts_of_speech',
    type: 'video',
    videoId: '4OwTmc2kuFc',
    requiresBadge: 'lesson_overview',
  },
  {
    id: 'dictionary_work',
    title: 'Работа со словарем',
    description: 'Видео-урок: как добавлять и оформлять слова в своём словаре.',
    badgeKey: 'lesson_dictionary_work',
    type: 'video',
    videoId: 'XFrpWuRV6WE',
    requiresBadge: 'lesson_parts_of_speech',
  },
  {
    id: 'how_to_learn',
    title: 'Как учить слова',
    description: 'Видео-урок о том, как пользоваться Norsk Pro для запоминания слов.',
    badgeKey: 'lesson_how_to_learn',
    type: 'video',
    videoId: 'PQC0NIZvA_A',
    requiresBadge: 'lesson_dictionary_work',
  },
  {
    id: 'innovations',
    title: 'Нововведения',
    description: 'В этом уроке вы узнаете о нескольких новых опциях, появившихся в Norsk Pro.',
    badgeKey: 'lesson_innovations',
    type: 'video',
    videoId: 'o25uMpeQamI',
    requiresBadge: 'lesson_how_to_learn',
  },
  {
    id: 'public_word',
    title: 'Публичное слово',
    description: 'Видео-урок о том, как делать свои слова публичными.',
    badgeKey: 'lesson_public_word',
    type: 'video',
    videoId: '7xv_gcBZ07A',
    requiresBadge: 'lesson_innovations',
  },
];

export const OVERVIEW_STEPS = [
  { target: 'logo', text: 'Логотип — твоя кнопка «домой». Он всегда вернёт тебя на главную страницу.' },
  { target: 'avatar', text: 'Это ты. Здесь твоё личное меню со всем, что касается твоего аккаунта.', autoOpen: 'popover' },
  { target: 'section-user_stats', text: 'Здесь видно сколько друзей у тебя и кто они. Также ты можешь видеть сколько у тебя подписчиков, и кто они. Слоники, которые здесь собираются, приходят к тебе за выполненные задания. Эта опция будет расширяться, поэтому следи за обновлениями.', autoOpen: 'section:user_stats' },
  { target: 'section-stats', text: 'Здесь видна твоя статистика по словам: сколько у тебя категорий, подкатегорий, слов, переводов и других элементов.', autoOpen: 'section:stats' },
  { target: 'btn-download-all', text: 'Сохранить все свои норвежские слова одним файлом. А знаешь для чего тебе нужен этот файл? О, это весьма полезная вещь в работе с ИИ, и мы тебе о ней расскажем.', autoOpen: 'section:stats' },
  { target: 'section-database', text: 'Твоя страховка. Можно скачать свою базу файлом, загрузить обратно или восстановить из архива, если что-то пропало.', autoOpen: 'section:database' },
  { target: 'btn-avatar', text: 'Здесь ты можешь загрузить свое фото для аватарки, и менять его когда захочешь.', autoOpen: 'section:settings' },
  { target: 'btn-skeleton', text: 'Эта опция восстановит твои части речи, если ты их по той или иной причине выключил, и снова захотел увидеть у себя на экране. Твои слова при этом не пострадают.', autoOpen: 'section:settings' },
  { target: 'btn-reload', text: 'Обновить приложение, если что-то подвисло.', autoOpen: 'section:settings' },
  { target: 'btn-logout', text: 'Выйти из аккаунта.', autoOpen: 'section:settings' },
  { target: 'btn-delete', text: 'Удалить аккаунт полностью. Осторожно — это нельзя отменить.', autoOpen: 'section:settings' },
];
